exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".square[data-v-4dca7005]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-right:1px solid #79a6d6;border-bottom:1px solid #79a6d6;background-color:#a0c0e2;font-weight:600;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-box-sizing:border-box;box-sizing:border-box}.square.transition[data-v-4dca7005]{-webkit-transition:all .4s ease;transition:all .4s ease}.square[data-v-4dca7005]:last-child{border-right:none}.square.isOpen[data-v-4dca7005]{background-color:#e9e9e9}", ""]);

// exports
